export default __webpack_public_path__ + "static/media/ray12.16beda5c.webp";